import { RouteProps } from '../../routes/AppRouter'
import { ProtocolList } from '../../features/protocols'
import React from 'react'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'

export function Protocols(props: RouteProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()

  setTitle(title)

  return <ProtocolList />
}
